import { ButtonV2 as Button } from '@/components/Button';
import ModalHoc from '@/components/ModalHoc';
import promptStyles from '@/components/ModalHoc/stylesPrompt.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ConfirmThemePrompt = _ref => {
  let {
    themeName = 'Unnamed',
    onClose,
    onConfirm
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("button", {
      className: styles.close,
      onClick: onClose,
      children: /*#__PURE__*/_jsx("img", {
        src: "/icons/close.svg"
      })
    }), /*#__PURE__*/_jsxs("header", {
      className: promptStyles.header,
      children: [/*#__PURE__*/_jsxs("h5", {
        className: promptStyles.heading,
        children: ["Apply ", themeName, " Theme?"]
      }), /*#__PURE__*/_jsx("p", {
        className: promptStyles.subHeading,
        children: "Applying this theme may remove some styles from your chart, continue?"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.actions,
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "gray",
        onClick: onClose,
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        onClick: onConfirm,
        children: "Confirm"
      })]
    })]
  });
};

export default ModalHoc(ConfirmThemePrompt, {
  modalClass: styles.modal,
  overlayclass: styles.overlay,
  hasCloseButton: false,
  indexable: true
});